import { render } from "./Chat.vue?vue&type=template&id=2db7214d&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=2db7214d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2db7214d"

export default script